import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a4d17a2ca334e0014446b62_1784461241608_b8af5f56/rostockritz/src/app/page.tsx");
